export default __webpack_public_path__ + "static/media/target-8@2x.98cb3ff6.png";